import script from "./ArticleHeading.vue?vue&type=script&lang=js"
export * from "./ArticleHeading.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__